<div class="card">
  <div class="card-header card-header-warning">
    <h4 class="card-title">Issues Detected</h4>
    <p class="card-category">Top sitemap issues that require attention</p>
  </div>
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="text-warning">
          <th>Priority</th>
          <th>Issue Type</th>
          <th>Problem</th>
          <th>Recommendation</th>
          <th>URL</th>
        </thead>
        <tbody>
          <tr *ngFor="let issue of issues">
            <td>
              <span [ngClass]="getPriorityClass(issue.priority)">{{ issue.priority }}</span>
            </td>
            <td>{{ issue.issueType }}</td>
            <td class="text-wrap" style="max-width: 250px;">{{ issue.problem }}</td>
            <td class="text-wrap" style="max-width: 250px;">{{ issue.recommendation }}</td>
            <td>
              <a [href]="issue.url" target="_blank" class="text-info">
                {{ issue.url | slice:0:30 }}{{ issue.url.length > 30 ? '...' : '' }}
                <i class="material-icons" style="font-size: 14px">open_in_new</i>
              </a>
            </td>
          </tr>
          <tr *ngIf="!issues || issues.length === 0">
            <td colspan="5" class="text-center py-4">
              <i class="material-icons text-success" style="font-size: 48px">check_circle</i>
              <p class="mt-2 text-muted">No sitemap issues detected!</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
